'use client';

import styled from 'styled-components';

import { Breakpoints } from '@zoomit/primitives';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import { useNotificationCount } from '../../hooks/notification';

const NotifBadge = () => {
  const { data: notifCount, isError } = useNotificationCount();

  return (
    <Root className="fa" $hasNotif={!!notifCount?.data && !isError} role={'status'}>
      <Typography spacing={{ mt: 0.2 }} className="fa" textColor={cssVar(theme.white)} variant="subhead">
        {notifCount?.data || 0}
      </Typography>
    </Root>
  );
};

export default NotifBadge;

const Root = styled.div<{ $hasNotif: boolean }>`
  background-color: ${cssVar(theme.primary1)};
  display: ${({ $hasNotif }) => ($hasNotif ? 'grid' : 'none')};
  place-items: center;
  height: 1.6rem;
  padding: 0 0.5rem;
  border-radius: var(${theme.radius.full});
  position: absolute;
  top: -0.5rem;
  right: -1rem;

  @media (min-width: ${Breakpoints.md}) {
    top: -1rem;
  }
`;
